export default __webpack_public_path__ + "static/media/blocked.f8d99d30.svg";